import type { MinistryIcon } from "@lbcrm-api/ministries/ministry-icons";
import {
    type Icon,
    IconBabyBottle,
    IconBabyCarriage,
    IconBackpack,
    IconBallFootball,
    IconBalloon,
    IconBeach,
    IconBible,
    IconBook,
    IconBook2,
    IconBooks,
    IconBuildingChurch,
    IconBus,
    IconCalendarStar,
    IconCampfire,
    IconCandle,
    IconChristmasTree,
    IconCoffee,
    IconCompass,
    IconCross,
    IconFlag,
    IconFlag2,
    IconFlag3,
    IconFlame,
    IconFriends,
    IconGift,
    IconHeart,
    IconHeartHandshake,
    IconHexagon,
    IconHorseToy,
    IconMessage2,
    IconMicrophone,
    IconMicrophone2,
    IconMoodKid,
    IconMusic,
    IconPencil,
    IconPiano,
    IconPlant,
    IconPlant2,
    IconPodium,
    IconPray,
    IconSchool,
    IconShirtSport,
    IconSnowflake,
    IconSparkles,
    IconStar,
    IconSun,
    IconTent,
    IconToolsKitchen2,
    IconTrophy,
    IconUsers,
    IconUsersGroup,
} from "@tabler/icons-react";

/** Typed against the API's list, so an icon added there fails this build until it is drawn */
export const ministryIcons: Record<MinistryIcon, Icon> = {
    hexagon: IconHexagon,
    "building-church": IconBuildingChurch,
    cross: IconCross,
    bible: IconBible,
    podium: IconPodium,
    pray: IconPray,
    candle: IconCandle,
    heart: IconHeart,
    "heart-handshake": IconHeartHandshake,
    star: IconStar,
    sparkles: IconSparkles,

    "baby-carriage": IconBabyCarriage,
    "baby-bottle": IconBabyBottle,
    "horse-toy": IconHorseToy,
    "mood-kid": IconMoodKid,
    balloon: IconBalloon,
    users: IconUsers,
    "users-group": IconUsersGroup,
    friends: IconFriends,
    compass: IconCompass,
    flag: IconFlag,
    "flag-2": IconFlag2,
    "flag-3": IconFlag3,
    trophy: IconTrophy,
    flame: IconFlame,

    book: IconBook,
    "book-2": IconBook2,
    books: IconBooks,
    school: IconSchool,
    pencil: IconPencil,
    backpack: IconBackpack,

    music: IconMusic,
    microphone: IconMicrophone,
    "microphone-2": IconMicrophone2,
    piano: IconPiano,

    "christmas-tree": IconChristmasTree,
    gift: IconGift,
    snowflake: IconSnowflake,
    sun: IconSun,
    beach: IconBeach,
    tent: IconTent,
    campfire: IconCampfire,
    plant: IconPlant,
    "plant-2": IconPlant2,

    "ball-football": IconBallFootball,
    "shirt-sport": IconShirtSport,

    coffee: IconCoffee,
    "tools-kitchen-2": IconToolsKitchen2,
    bus: IconBus,
    "message-2": IconMessage2,
    "calendar-star": IconCalendarStar,
};

export const isMinistryIcon = (icon: string | null | undefined): icon is MinistryIcon =>
    !!icon && Object.hasOwn(ministryIcons, icon);

/** A ministry nobody has chosen an icon for keeps the hexagon it always had */
export const ministryIconFor = (icon: string | null | undefined): Icon =>
    isMinistryIcon(icon) ? ministryIcons[icon] : IconHexagon;
